/**
 * 组件的emit事件声明
 * 基于方案设计文档生成
 */
export const emits = [
  /** 滚动时触发 */
  'scroll',
  /** 滚动到顶部/左边时触发，单向触发 */
  'scrolltoupper',
  /** 滚动到底部/右边时触发，单向触发 */
  'scrolltolower',
  /** 滚动到顶部/左边或底部/右边，threshold所在位置与边缘切割时触发，双向触发（仅 LiteApp） */
  'scrolltothreshold',
  /** 滚动停止时触发（仅 LiteApp，最低版本：2025.T1(8.0.57)） */
  'scrollend',
];


